import { isIO, isTL_CT_IO } from "../../utils/feature-flag-key";
import { COMPANY_CODE, USER_ROLES } from "../../utils/Utils";
const { DRIVER, BILL_APPROVER, SHIFT_LEADER, STAFF, ENTRY_STAFF, MANAGER, OFFICE_WORKER } =
  USER_ROLES;
const menu = [
  {
    icon: "list-round",
    text: "Quản lý đơn hàng",
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    roles: [BILL_APPROVER, ENTRY_STAFF, MANAGER],
    subMenu: [
      {
        text: "Đơn vận chuyển",
        link: "/pn/bill",
        roles: [ENTRY_STAFF, BILL_APPROVER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Đơn vận chuyển",
        link: "/bill",
        roles: [ENTRY_STAFF, BILL_APPROVER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn phí cảng bãi",
        link: "/bill-external-port-fee",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn phí cảng bãi",
        link: "/pn/bill-external-port-fee",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Đơn phí khác",
        link: "/bill-other",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn phí khác cần duyệt",
        link: "/bill-other-must-request",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn phí khác",
        link: "/pn/bill-other",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Đơn nhận gia công",
        link: "/processing-bill",
        roles: [ENTRY_STAFF, BILL_APPROVER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn còn ở trạm cân",
        link: "/draff-bill",
        roles: [ENTRY_STAFF, BILL_APPROVER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Hợp đồng xuất khẩu",
        link: "/bill-external-contract",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Theo dõi Hợp đồng tháng",
        link: "/bill-external-contract-by-month",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },

      {
        text: "Đơn phí nhân viên",
        link: "/pn/bill-staff-money-flow",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "box",
    text: "Quản lý gia công",
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
    roles: [BILL_APPROVER, ENTRY_STAFF, MANAGER],
    subMenu: [
      {
        text: "Kho gia công",
        link: "/processing-inventory",
        roles: [BILL_APPROVER, ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
    ],
  },
  {
    icon: "reports",
    text: "Báo cáo",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Theo ngày",
        link: "/daily-report",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Vận chuyển",
        link: "/delivery-report",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Công nợ tổng hợp năm",
        link: "/customer/report-all-customer",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Công nợ tổng hợp năm",
        link: "/pn/report-all-customer",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Biểu đồ nguyên liệu",
        link: "/report/report-ingredient",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Biểu đồ thu chi",
        link: "/report/report-category",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Chi tiết Thu Chi",
        link: "/report/transaction",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },

      {
        text: "Chi tiết thu chi",
        link: "/pn/report/transaction",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },

      {
        text: "Tổng hợp sổ quỹ",
        link: "/report/report-all-bank-accounts",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },

      {
        text: "Tổng hợp sổ quỹ",
        link: "/pn/report/report-all-bank-accounts",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },

      {
        text: "Dòng tiền theo tháng",
        link: "/report/monthly-report",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "H.Hồng theo NV",
        link: "/report/report-commission-per-month",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Hoa hồng tháng",
        link: "/report/monthly-commission",
        roles: [MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      ...(isTL_CT_IO ? [
        {
          text: "Tỉ lệ thu hồi kho",
          link: "/report/ingredient-exchange-history",
          roles: [ENTRY_STAFF, MANAGER],
          companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
        },
      ] : []),
      {
        text: "Giao dịch từ NH",
        link: "/bank-hook-transactions",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Giao dịch từ NH",
        link: "/pn/bank-hook-transactions",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Báo cáo việc CN",
        link: "/report/tasks",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "B.Cáo thưởng T.Xế",
        link: "/pn/report-driver-bonus",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      }


    ],
  },
  {
    icon: "ticket",
    text: "Quản lý thuế",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],

    subMenu: [
      {
        text: "Thuế",
        link: "/tax",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Báo cáo Thuế",
        link: "/tax-report",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "users",
    text: "Quản lý KH/NCC",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
    link: "/customer",
  },

  {
    icon: "users",
    text: "Quản lý KH/NCC",
    link: "/pn/customer",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.PN],

  },
  {
    icon: "user-list",
    text: "Quản lý nhân viên",
    roles: [SHIFT_LEADER, MANAGER, ENTRY_STAFF],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {

        text: "Tài khoản",
        link: "/user",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Tổng hợp chi phí tài xế",
        link: "/pn/report-money-flow-driver",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Tổng hợp chi phí & ứng tài xế",
        link: "/pn/report-driver-cost-advance",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Xuống cấn",
        link: "/employee/piece-wage",
        roles: [SHIFT_LEADER, MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Tổng hợp xuống hàng",
        link: "/piece-wage-summary-by-categories",
        roles: [SHIFT_LEADER, MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Chấm công",
        link: "/time-keeping",
        roles: [SHIFT_LEADER, MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Phần ăn",
        link: "/employee-portion",
        roles: [SHIFT_LEADER, MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Bảng chấm công",
        link: "/employee-scheduling",
        roles: [SHIFT_LEADER, MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Phép năm nhân viên",
        link: "/employee-day-off",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Ngày nghi nhân viên",
        link: "/pn/employee-leave",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Tiền thưởng/nợ của NV",
        link: "/employee-pay-in-out",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Lương tháng",
        link: "/salary-per-month",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Lương tháng",
        link: "/pn/salary-per-month",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "list-check",
    text: "Duyệt/Chốt đơn",
    roles: [ENTRY_STAFF, MANAGER, SHIFT_LEADER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Sửa đơn",
        link: "/bill/list-request-update-bill",
        roles: [MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Chốt ngày đơn",
        link: "/bill-approved",
        roles: [MANAGER, ENTRY_STAFF, BILL_APPROVER, SHIFT_LEADER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn trạm cân",
        link: "/bill-station",
        roles: [MANAGER, ENTRY_STAFF, BILL_APPROVER, SHIFT_LEADER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Sửa thu chi",
        link: "/transaction-history/list-preview-update-manager",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Chốt ngày thu chi",
        link: "/report/approved-transaction",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Sửa thu chi KH/NCC",
        link: "/customer-money-flow/list-preview-update-manager",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Chốt ngày thu chi PN",
        link: "/report/assign-transaction-history-pn",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Chốt tiên tài chi PN",
        link: "/report/assign-staff-money-flow-pn",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "wallet",
    text: "Quản lý thu/chi",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Quỹ tài khoản",
        link: "/bank-account",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Quỹ tài khoản",
        link: "/pn/bank-account",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "DM Thu/Chi",
        link: "/category",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
    ],
  },
  {
    icon: "wallet-saving",
    text: "Khoản Vay",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],

    subMenu: [
      {
        text: "DS vay",
        link: "/loan-contract",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Thu chi",
        link: "/mortgage-transaction-history",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },

      {
        text: "Báo cáo",
        link: "/report/report-mortgage-contracts",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Báo cáo chi tiết",
        link: "/report/report-mortgage-contracts-detail-contracts",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "hot",
    text: "Quản lý túi",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
    subMenu: [
      {
        text: "Tồn kho túi",
        link: "/inventory-pack-summary",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Xuất nhập túi",
        link: "/inventory-pack-transaction",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
    ]
  },

  {
    icon: "package",
    text: "Quản lý nhiên liệu",
    roles: [ENTRY_STAFF, SHIFT_LEADER, MANAGER],
    companies: [COMPANY_CODE.PN, COMPANY_CODE.TL, COMPANY_CODE.CT],
    subMenu: [
      {
        text: "Tồn kho nhiên liệu",
        link: "/inventory",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN, COMPANY_CODE.TL, COMPANY_CODE.CT],
      },

      {
        text: "Nhập nhiên liệu",
        link: "/inventory-in",
        roles: [ENTRY_STAFF, SHIFT_LEADER, MANAGER],
        companies: [COMPANY_CODE.PN, COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đổ nhiên liệu",
        link: "/inventory-out-inside",
        roles: [ENTRY_STAFF, SHIFT_LEADER, MANAGER],
        companies: [COMPANY_CODE.PN, COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đổ dầu ngoài",
        link: "/pn-inventory-out-outside",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Tổng hợp nhập xuất nhiên liệu",
        link: "/inventory-summary",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN, COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Báo cáo vận chuyển",
        link: "/transport-report",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Khoảng cách xe",
        link: "/truck-monitor",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "dashlite",
    text: "QL Phương Nam",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.PN],
    subMenu: [

      {
        text: "Báo cáo chi phí",
        link: "/pn/report-fee",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Báo cáo tổng kết",
        link: "/pn/report-pn",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Quản lý thay vỏ",
        link: "/pn/tire",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Báo cáo thặng dư",
        link: "/pn/report-truck-profit",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },

  {
    icon: "meter",
    text: "VC Phương Nam",
    roles: [ENTRY_STAFF, MANAGER, SHIFT_LEADER],
    companies: [COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Phiếu điều xe",
        link: "/pn-request-bill",
        roles: [ENTRY_STAFF, MANAGER, SHIFT_LEADER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Cảng biển",
        link: "/pn/seaport",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Cài giá theo KM",
        link: "/pn/delivery-fee-by-distance",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Khoảng cách tải",
        link: "/location-distance-manager",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Hợp đồng theo KM",
        link: "/pn/drive-rental-contract",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },

  {
    icon: "masonry",
    text: "Vật tư",
    roles: [ENTRY_STAFF, MANAGER, SHIFT_LEADER, STAFF, OFFICE_WORKER, BILL_APPROVER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Danh mục vật tư",
        link: "/material",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Tồn kho vật tư",
        link: "/material-summary",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Quản lý yêu cầu",
        link: "/material-inventory-request",
        roles: [ENTRY_STAFF, MANAGER, SHIFT_LEADER, STAFF, OFFICE_WORKER, BILL_APPROVER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },


    ],
  },
  {
    icon: "setting",
    text: "Cài đặt",
    roles: [ENTRY_STAFF, MANAGER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Xe",
        link: "/truck",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN, COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Tiền tài xế",
        link: "/truck-config",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Nguyên liệu",
        link: "/ingredient",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Lịch hàng",
        link: "/ingredient-schedule",
        roles: [MANAGER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn giá nguyên liệu",
        link: "/ingredient-price",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Giá vận chuyển",
        link: "/delivery-fee",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Danh mục xuống hàng",
        link: "/setting/price-wage-category",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Quản lý đầu kỳ",
        link: "/summary-statement",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Quản lý đầu kỳ",
        link: "/pn/summary-statement",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Ngày nghỉ lễ",
        link: "/holiday",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Quản lý kho",
        link: "/warehouse",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Cài đặt hoa hồng",
        link: "/sale-commission-setting",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      {
        text: "Đơn giá gia công",
        link: "/processing-unit-price",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
      ...(isTL_CT_IO ? [
        {
          text: "Tỉ lệ QĐNL",
          link: "/ingredient-exchange",
          roles: [ENTRY_STAFF, MANAGER],
          companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
        },
      ] : []),
      {
        text: "Hợp đồng xuất khẩu",
        link: "/setting-bill-external-contract",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },

      {
        text: "Khác",
        link: "/setting",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Mẫu tạo NV",
        link: "/employee-template",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Vật tư",
        link: "/material",
        roles: [ENTRY_STAFF, MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Danh mục công việc",
        link: "/task-categories",
        roles: [MANAGER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },
    ],
  },
  {
    icon: "user",
    text: "Công nhân viên",
    roles: [STAFF, SHIFT_LEADER, DRIVER, ENTRY_STAFF],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
    subMenu: [
      {
        text: "Công việc hằng ngày",
        link: "/my-tasks",
        roles: [STAFF, SHIFT_LEADER, DRIVER, ENTRY_STAFF],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Phí cảng bãi của tôi",
        link: "/my-bill-for-external-port-fee",
        roles: [DRIVER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Chấm công của tôi",
        link: "/my-time-keeping",
        roles: [STAFF, SHIFT_LEADER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Bảng lương của tôi",
        link: "/my-salary-per-month",
        roles: [STAFF, SHIFT_LEADER, DRIVER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
      },
      {
        text: "Xuống hàng của tôi",
        link: "/my-piece-wage",
        roles: [STAFF, SHIFT_LEADER],
        companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
      },

      {
        text: "Thưởng chuyến xe của tôi",
        link: "/my-driver-bonus",
        roles: [DRIVER],
        companies: [COMPANY_CODE.PN],

      },
      {
        text: "Tiền tài xế chi ",
        link: "/my-bill-for-staff-money-flow-manager",
        roles: [DRIVER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Chạy xe thuê",
        link: "/my-bill-for-rental-contract-manager",
        roles: [DRIVER],
        companies: [COMPANY_CODE.PN],
      },
      {
        text: "Đổ dầu ngoài",
        link: "/my-inventory-out-outside-transaction",
        roles: [DRIVER],
        companies: [COMPANY_CODE.PN],
      },
    ],
  },
  {
    icon: "scan",
    text: "Quét mã QR",
    link: "/scan-qr-system",
    roles: [STAFF, SHIFT_LEADER, DRIVER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT, COMPANY_CODE.PN],
  },
  {
    // Quét QR phiếu cân gia công -> tạo đơn thuê gia công (tách riêng khỏi "Quét mã QR")
    icon: "scan",
    text: "Quét QR gia công",
    link: "/scan-qr-outsourcing",
    roles: [OFFICE_WORKER, ENTRY_STAFF, BILL_APPROVER],
    companies: [COMPANY_CODE.TL, COMPANY_CODE.CT],
  },
];
export default menu;
